module.exports = __webpack_public_path__ + "static/multi-destinations.360ab791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHome/images/multi-destinations.jpg
// module id = 181
// module chunks = 168707334958949